import { useNavigate } from 'react-router';

const LoginPromptModal = ({ isOpen, onClose, title = null, description = null }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box text-center">
        <div className="text-5xl mb-4">🤔</div>
        <h3 className="font-bold text-xl mb-2">{title || "Oops! Login Required"}</h3>
        <p className="text-gray-600">{description || "You need to be logged in to perform this action"}</p>
        <div className="modal-action">
          <button className="btn btn-outline" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={() => {
              navigate('/login');
              onClose()
            }}
          >
            Login
          </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose}>
        <button className="cursor-default">&nbsp;</button>
      </div>
    </div>
  );
};

export default LoginPromptModal;
